"use client";

import React from "react";
import { Settings, ShieldCheck, Truck, RefreshCw, Zap, Layers } from "lucide-react";
const hardwareItems = [{
  id: 1,
  title: "Industrielle Reinigungsanlagen",
  description: "Hochmoderne Spülstraßen für maximale Hygiene und Effizienz bei jedem Event.",
  icon: RefreshCw,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650013/img/cleaning_machinery.png"
}, {
  id: 2,
  title: "Spezial-Transportboxen",
  description: "Robuste, stapelbare Logistiklösungen für sicheren Transport und platzsparende Lagerung.",
  icon: Layers,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650013/img/transport_crates.png"
}, {
  id: 3,
  title: "Premium Mehrwegbecher",
  description: "Bruchsicheres Material mit ergonomischem Design für das beste Trinkerlebnis.",
  icon: ShieldCheck,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650013/img/premium_cups_display.png"
}];
const features = [{
  label: "Präzision",
  icon: Settings
}, {
  label: "Schnelligkeit",
  icon: Zap
}, {
  label: "Zuverlässigkeit",
  icon: Truck
}];
export default function FeaturedDisplayHardware() {
  return;
}